import { ICreateIntegrators } from './interface';

export const CreateIntegrator: ICreateIntegrators = {
  _id: '',
  name: '',
  description: '',
  active: false,
  modules: [],
};
